import { atom, RecoilState } from 'recoil'
import { NotificationProps } from '../components/common'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const notificationsState: RecoilState<NotificationProps[]> = atom({
  key: 'notifications',
  default: [],
})
